export function armarMailFinalizacion(datos) {

  const asunto =
    datos.categoria === 281
      ? "Área Técnica, Instalación finalizada"
      : datos.categoria === 282
        ? "Área Técnica, Desconexión finalizada"
        : "Área Técnica, Reclamo finalizado";

  const planta = datos.nombre_sucursal

  const tabla = `
    <table style="width: 50%; border-collapse: collapse; margin-top: 10px;">
      ${fila("N°", datos.id_reclamo)}
      ${fila("Cliente", datos.razon_social)}
      ${fila("Motivo", datos.descripcion_motivo)}
      ${fila("Acciones Realizadas", datos.detalles_finalizacion)}
      ${fila("Asignado al técnico", datos.razon_prov)}
      ${fila("Planta", planta)}
    </table>
  `;

  const html = `
    <p>Se finalizó el reclamo:</p>
    ${tabla}
  `;

  return { asunto, html };
}

// --- Función helper interna reutilizable ---
function fila(titulo, valor) {
  return `
    <tr>
      <td style="border: 1px solid #ccc; padding: 8px; font-weight: bold;">${titulo}</td>
      <td style="border: 1px solid #ccc; padding: 8px;">${valor ?? ""}</td>
    </tr>
  `;
}
